import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import routes from 'routes/index';
import privateRoutes from 'routes/private.index';
import PublicRoute from 'routes/PublicRoute';
import NotFound from 'components/notFound/NotFound';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'App.scss';
import PrivateRoute from 'routes/AuthRoute';
import { useDispatch, useSelector } from 'react-redux';
import ImageViewer from 'components/imageViewer/ImageViewer';
import { closeImageViewer } from 'store/reducers/imageViewer.reducer';
import { RootState } from 'store/combineReducers';
import { broadCastStorage } from './helpers/utils';
import { setSelectedBroadCast } from './store/actions/conversation.actions';
import { init } from "@plausible-analytics/tracker";

function App() {
  document.title = 'Social Play';
  const dispatch = useDispatch();
  const imageViewer = useSelector((s: RootState) => (s as any).imageViewer || { isOpen: false });

  useEffect(() => {
    const broadCast = broadCastStorage.get();
    if (broadCast) {
      dispatch(setSelectedBroadCast(broadCast));
    }
  }, []);

  useEffect(() => {
    // @ts-ignore
    window.process = {...window.process};
  }, []);

  // Init Plausible Analytics
  useEffect(() => {
    init({
      domain: "socialplay.com",
      autoCapturePageviews: true,
    });
  }, [])

  return (
    <div className="App">
      <div>
        <Switch>
          {privateRoutes &&
          privateRoutes.map((route, key) => <PrivateRoute key={key} path={route.path} component={route.component} />)}
          {routes &&
            routes.map((route, key) => <PublicRoute key={key} path={route.path} component={route.component} />)}
          <Redirect exact from="/" to="/login" />
          <Route component={NotFound} />
        </Switch>
      </div>
      <ToastContainer hideProgressBar />
      {imageViewer.isOpen && imageViewer.imageUrl && (
        <ImageViewer
          imageUrl={imageViewer.imageUrl}
          imageName={imageViewer.imageName}
          onClose={() => dispatch(closeImageViewer())}
        />
      )}
    </div>
  );
}

export default App;
